// extracted by mini-css-extract-plugin
export var closeButton = "_ht-1";
export var closeX = "_ht-3";
export var container = "_ht-0";
export var image = "_ht-2";